<template>
  <div class="loginPage">
    <v-container class="custom-container bg-register forgot-password">
      <v-row no-gutters>
        <v-col md="12">
          <div class="top-bar-register">
            <div class="logo-wrapper">
             <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
            </div>
            <LanguageMenu></LanguageMenu>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-10 mb-10" no-gutters>
        <v-col md="7" sm="9" cols="11">
          <h3 class="justify-center">Log in</h3>
          <v-form class="deposit-form password-field">
            <div class="form-details">
              <fieldset>
                <legend>Email</legend>
                <v-text-field :value="loginInfo.email" @input="LOGIN_EMAIL" placeholder="Enter your name" single-line
                  solo hide-details class="custom-select" autocomplete="false" aria-autocomplete="none"></v-text-field>
              </fieldset>
              <fieldset>
                <legend>Password</legend>
                <v-text-field placeholder="Enter Here" :value="loginInfo.password" @input="LOGIN_PASSWORD"
                  :append-icon="viewPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="viewPassword ? 'text' : 'password'"
                  counter @click:append="VIEW_PASSWORD" single-line solo hide-details class="custom-select"
                  autocomplete="false" aria-autocomplete="none"></v-text-field>
              </fieldset>
              <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                :disabled="!validToLogin" @click.prevent="LOGIN">
                Log in
              </v-btn>
              <div class="forget-link">
                <router-link to="/forget-password">Forget Password?</router-link>
              </div>
              <div class="another-link">
                <p>
                  Don’t have any account?
                  <router-link to="/create-account">Create new account</router-link>
                </p>
              </div>
              <social-icons :info="genInfo"></social-icons>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center" class="mb-5">
        <v-col md="5">
          <p class="emailLink text-center">
            <strong>High Risk Investment Warning:</strong> Trading Leveraged
            Products such as Forex and Derivatives may not be suitable for all
            investors as they carry a high degree of risk to your capital. Please
            ensure that you fully understand the risks involved, taking into
            account your investments objectives and level of experience, before
            trading, and if necessary, seek independent advice.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import { AUTHENTICATION__ACTIONS, PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";
import { AUTHENTICATION__MUTATIONS } from "@/store/mutation-types";
import SocialIcons from "./SocialIcons.vue";

export default {
  components: { LanguageMenu, SocialIcons },
  data: () => ({
    genInfo: {}
  }),
  computed: {
    ...mapState("publicinfo", ["info"]),
    ...mapState("authentication", ["loginInfo", "viewPassword"]),
    ...mapGetters("authentication", ["validToLogin"]),

    logoSrc() {
      return this.info?.logo_url || null;  // Changed from generalInfo to info
    },

    companyName() {
      return this.info?.company_name || "Forex Crm";  // Changed from generalInfo to info
    },

    logoWidth() {
      return this.info?.logo_width || "50px";  // Changed from generalInfo to info
    },
    
    logoHeight() {
      return this.info?.logo_height || "50px";  // Changed from generalInfo to info
    }
  },
  methods: {
    ...mapMutations("authentication", {
      LOGIN_EMAIL: AUTHENTICATION__MUTATIONS.LOGIN_EMAIL,
      LOGIN_PASSWORD: AUTHENTICATION__MUTATIONS.LOGIN_PASSWORD,
      VIEW_PASSWORD: AUTHENTICATION__MUTATIONS.VIEW_PASSWORD,
    }),

    ...mapActions("authentication", {
      LOGIN: AUTHENTICATION__ACTIONS.LOGIN,
    }),

    ...mapActions("publicinfo", [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]),
  },

  async mounted() {
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    this.genInfo = this.info;

    if (this.$route.params.verify == 1) {
      toast.success("Your account is successfully verified");
    }
    if (this.$route.params.verify == 2) {
      toast.error("Your account has been verified already");
    }
  },

  async created() {
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    this.genInfo = this.info;
  },
};
</script>

<style>
.v-main__wrap{
  overflow-y: scroll !important;
  height: 100vh;
}
</style>
